export const analysesRatioFormat = (occurrences: number, timeInMS: number): string => {
  const MS_PER_HOUR = 1000 * 60 * 60;
  const MS_PER_MINUTE = 1000 * 60;
  const hours = Math.floor(timeInMS / MS_PER_HOUR);

  let ratio: { occurrences: string; time: string };
  if (hours === 0) {
    const minutes = Math.floor(timeInMS / MS_PER_MINUTE);
    if (minutes === 0) {
      ratio = { occurrences: "0", time: "" };
    } else if (occurrences === 0) {
      ratio = { occurrences: "0", time: minutes.toString() };
    } else if (occurrences >= minutes) {
      ratio = { occurrences: Math.ceil(occurrences / minutes).toString(), time: "" };
    } else {
      ratio = { occurrences: "1", time: Math.ceil(minutes / occurrences).toString() };
    }
    return `${ratio.occurrences} / ${ratio.time} min`;
  }

  if (occurrences === 0) {
    ratio = { occurrences: "0", time: "" };
  } else if (occurrences >= hours) {
    ratio = { occurrences: Math.ceil(occurrences / hours).toString(), time: "" };
  } else {
    ratio = { occurrences: "1", time: Math.ceil(hours / occurrences).toString() };
  }

  return `${ratio.occurrences} / ${ratio.time} h`;
};
